import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const TileTitle = ({ title, rightNode, rightNodeAbsolute = false }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="row align-items-center">
        <div className="col">{title}</div>
        {rightNode && (
          <div className="col right-node-container">{rightNode}</div>
        )}
      </div>
      <style jsx>{`
        .details-title {
          text-transform: ${theme.text.transform};
        }
        .right-node-container {
          position: ${rightNodeAbsolute ? 'absolute' : 'relative'};
          text-align: right;
        }
      `}</style>
    </>
  );
};

TileTitle.propTypes = {
  rightNode: PropTypes.node,
  rightNodeAbsolute: PropTypes.bool,
  title: PropTypes.string,
};

TileTitle.defaultProps = {
  rightNode: null,
  title: '',
};

export default TileTitle;
